/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}

function addPolicyTableOfContents() {
  const policyBody = document.querySelector('.shopify-policy__body');
  if (!(policyBody instanceof HTMLElement) || policyBody.querySelector('.kult-policy-toc')) return;

  const headings = [...policyBody.querySelectorAll('h2')].filter((heading) => heading.textContent?.trim());
  if (headings.length < 4) return;

  const nav = document.createElement('nav');
  nav.className = 'kult-policy-toc';
  nav.setAttribute('aria-label', 'On this page');

  const title = document.createElement('strong');
  title.textContent = 'On this page';
  nav.append(title);

  const list = document.createElement('ul');
  headings.forEach((heading, index) => {
    const id = heading.id || `policy-section-${index + 1}`;
    heading.id = id;

    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = `#${id}`;
    link.textContent = heading.textContent.trim();
    item.append(link);
    list.append(item);
  });

  nav.append(list);
  policyBody.prepend(nav);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', addPolicyTableOfContents, { once: true });
} else {
  addPolicyTableOfContents();
}
